<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div class="custom-table-design">
      <el-table
        :data="userDataList"
        :fit="true"
        stripe
        height="100"
        :row-class-name="tableRowClassName"
        @row-click="handleRowClick"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
      <el-table-column
          :label="'Name'"
          :prop="'name'"
          :width="$vuetify.display.width <= 1100 ? 200 : ''"
          sortable
        >
        <template #default="scope">
          <span
            v-if="$vuetify.display.width <= 1100"
            > {{ shorterLabel(scope.row.name, 10, 15, "...") }} </span
          >
          <span
            v-if="$vuetify.display.width > 1600"
            > {{ scope.row.name }} </span
          >
        </template>
        </el-table-column>
        <el-table-column
          :label="'Start Date'"
          :prop="'start_date'"
          :width="$vuetify.display.width <= 1110 ? 200 : ''"
          sortable
        >
          <template #default="scope">
            <span> {{ scope.row.start_date.replace('T', ' ') }} </span
          >
          </template>
        </el-table-column>
        <el-table-column
          :label="'End Date'"
          :prop="'end_date'"
          :width="$vuetify.display.width <= 1110 ? 200 : ''"
          sortable
          >
          <template #default="scope">
            <span> {{ scope.row.end_date.replace('T', ' ') }} </span
          >
          </template>
        </el-table-column>
        <el-table-column
          :label="'Status'"
          :prop="'status_display'"
          :width="$vuetify.display.width <= 1110 ? 200 : ''"
          sortable
        >
          <template #default="scope">
            <span
              v-if="$vuetify.display.width <= 1110"
              :class="{
                'text-success': scope.row.status === 'active',
                'text-danger': scope.row.status === 'inactive',
              }"
              > {{ shorterLabel(scope.row.status_display, 15, 15, "...")  }} </span
            >
            <span
              v-if="$vuetify.display.width > 1600"
              :class="{
                'text-success': scope.row.status === 'active',
                'text-danger': scope.row.status === 'inactive',
              }"
              > {{ scope.row.status_display }} </span
            >
          </template>
          
        </el-table-column>


        <!-- <el-table-column
          v-if="
            $vuetify.display.width < 500 &&
            $store.state.auth.user != null &&
            !$store.state.auth.user.is_auditor
          "
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="200"
        >
          <template #default="scope">
            <el-button
              color="#0d3937"
              @click.stop="handleShow(scope.$index, scope.row)"
              size="small"
              class="me-primary-light"
            >
              <i class="fa fa-eye"></i>
              <span class="pl-1">Update</span>
            </el-button>
            <el-button
              color="#0d3937"
              @click.stop="deleteRow(scope.row, scope.$index)"
              size="small"
              class="me-primary-light"
            >
              <i class="fa fa-trash"></i>
              <span class="pl-1"> Delete </span>
            </el-button>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          v-else-if="
            $store.state.auth.user != null && !$store.state.auth.user.is_auditor
          "
          fixed="right"
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="150"
        >
          <template #default="scope">
            <el-button
              color="#0d3937"
              @click.stop="handleShow(scope.$index, scope.row)"
              class="me-primary-light"
            >
              <i class="fa fa-edit"></i>
            </el-button>
            <el-button
              color="#0d3937"
              @click.stop="deleteRow(scope.row, scope.$index)"
              class="me-primary-light"
            >
              <i class="fa fa-trash"></i>
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

    <!-- <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="5"
          class="d-flex justify-content-start align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
            <el-option label="10" :value="'10'" />
            <el-option label="25" :value="'25'" />
            <el-option label="50" :value="'50'" />
            <el-option label="100" :value="'100'" />
          </el-select>
        </el-col>
        <el-col
          :span="8"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col :span="5" class="d-flex justify-content-end align-items-center">
          <span class="text-white">
            {{ (current_page - 1) * perPageCount + 1 }}-{{
              current_page * perPageCount > total_items
                ? total_items
                : current_page * perPageCount
            }}
            of {{ total_items }}
          </span>
        </el-col>
      </el-row>
    </div> -->

    <!-- <div class="custom-pagination" v-if="$vuetify.display.width < 700">
      <el-row class="row-bg" justify="space-between">
        <el-col
          :span="24"
          class="d-flex align-items-center justify-content-center"
        >
          <el-pagination
            small
            background
            layout="prev, pager, next"
            :total="total_items"
            v-model:page-size="page_size"
            v-model:current-page="current_page"
            @current-change="changePage"
            class="my-4"
          />
        </el-col>
        <el-col
          :span="10"
          class="d-flex justify-content-end align-items-center"
        >
          <el-select
            v-model="perPageCount"
            placeholder="Select"
            size="small"
            style="width: 70px"
          >
            <el-option label="10" :value="'10'" />
            <el-option label="25" :value="'25'" />
            <el-option label="50" :value="'50'" />
            <el-option label="100" :value="'100'" />
          </el-select>
        </el-col>

        <el-col :span="10" class="d-flex justify-content-start align-items-center">
          <span class="text-white">
            {{ (current_page - 1) * perPageCount + 1 }}-{{
              current_page * perPageCount > total_items
                ? total_items
                : current_page * perPageCount
            }}
            of {{ total_items }}
          </span>
        </el-col>
      </el-row>
    </div> -->

    </div>
  </el-col>
</template>

<script>
// import { ElMessageBox } from "element-plus";
// import ShowDetail from "./dialogDetail.vue";
// import UserService from "../../services/user.service";

import { shorterLabel } from '../../dashboard/common/common-tools';

export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
      immediate: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    shorterLabel(inputLabel, length, maxLabelLength, optionalAddition) {
      let label = shorterLabel(inputLabel, length, maxLabelLength, optionalAddition);
      return label;
    },


    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleShow(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    deleteRow(event, index) {
      this.$emit("tableAction", { index: index, data: event, kind: "delete" });
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>
